import {
  FaBlog,
  FaBluesky,
  FaBuilding,
  FaCalendarDays,
  FaCameraRetro,
  FaChevronLeft,
  FaChevronRight,
  FaCircleCheck,
  FaCircleMinus,
  FaCircleXmark,
  FaCompactDisc,
  FaEnvelopeOpenText,
  FaFacebook,
  FaFilm,
  FaGithub,
  FaHouse,
  FaInstagram,
  FaLinkedin,
  FaMagnifyingGlassPlus,
  FaPencil,
  FaPhone,
  FaQuoteLeft,
  FaQuoteRight,
  FaReddit,
  FaRegBookmark,
  FaRegClock,
  FaRegCommentDots,
  FaRegEnvelope,
  FaRegFileLines,
  FaRegImages,
  FaRegMap,
  FaRegNewspaper,
  FaRotateLeft,
  FaShareFromSquare,
  FaThreads,
  FaTrophy,
  FaUpRightAndDownLeftFromCenter,
  FaXmark,
  FaXTwitter,
  FaYoutube
} from "react-icons/fa6"

const fa6Icons = Object.freeze({
  FaBlog,
  FaBluesky,
  FaBuilding,
  FaCalendarDays,
  FaCameraRetro,
  FaChevronLeft,
  FaChevronRight,
  FaCircleCheck,
  FaCircleMinus,
  FaCircleXmark,
  FaCompactDisc,
  FaEnvelopeOpenText,
  FaFacebook,
  FaFilm,
  FaGithub,
  FaHouse,
  FaInstagram,
  FaLinkedin,
  FaMagnifyingGlassPlus,
  FaPencil,
  FaPhone,
  FaQuoteLeft,
  FaQuoteRight,
  FaReddit,
  FaRegBookmark,
  FaRegClock,
  FaRegCommentDots,
  FaRegEnvelope,
  FaRegFileLines,
  FaRegImages,
  FaRegMap,
  FaRegNewspaper,
  FaRotateLeft,
  FaShareFromSquare,
  FaThreads,
  FaTrophy,
  FaUpRightAndDownLeftFromCenter,
  FaXTwitter,
  FaXmark,
  FaYoutube
})

export default fa6Icons
